<template>
  <van-form ref="form" @submit="submit" @failed="failed" validate-trigger="onBlur" scroll-to-error validate-first>
    <!-- 封面 - start -->
    <van-image class="collect-form-cover-img" v-if="formDefinition.coverImg" :src="'/idata' + formDefinition.coverImg" width="100%"></van-image>
    <!-- 封面 - end -->

    <!-- 表单标题及说明 - start -->
    <div class="collect-form-head">
      <div>
        <span class="anonymous-pill" v-if="'T' == formDefinition.anonymous">匿名</span>
        <span class="collect-form-title">{{ formDefinition.subject }}</span>
      </div>
      <span class="collect-form-description" v-if="formDefinition.description">{{ formDefinition.description }}</span>
    </div>
    <!-- 表单标题及说明 - end -->

    <!-- 表单正文 - start -->
    <div class="collect-form-body">
      <CollectFormItem
        v-for="(item, index) in formDefinition.itemList"
        :key="index"
        :formId="formDefinition.id"
        :item="item"
        :serialNumberType="formDefinition.serialNumber"
        :readonly="readonly"
      ></CollectFormItem>
    </div>
    <!-- 表单正文 - end -->

    <!-- 底部按钮 - start -->
    <div class="collect-form-action" v-if="!readonly">
      <van-button native-type="submit" type="primary" size="large" class="collect-form-submit-btn">{{ "T" == formDefinition.anonymous ? "匿名" : "" }}提交</van-button>
    </div>
    <!-- 底部按钮 - end -->

    <!-- 回顾按钮 - start -->
    <transition name="review-btn">
      <div v-if="!readonly && scrollEnoughHeight" class="collect-form-review-btn" @click="showReviewWindow">
        <div style="text-align: center; font-size: 20px">
          <van-icon name="completed" />
        </div>
        <div style="font-size: 12px">回顾</div>
      </div>
    </transition>
    <!-- 回顾按钮 - end -->

    <!-- 回顾窗口 - start -->
    <van-popup v-model="reviewWindowShowFlag" closeable round position="bottom" :style="{ height: '75%' }" class="review-window">
      <div class="review-window-title">已答题目回顾</div>
      <template v-for="item in formDefinition.itemList">
        <div
          v-if="item.display && 'value' in item && typeof (item.value) != 'undefined' && (typeof item.value == 'number' ? true : item.value.length > 0)"
          :key="item.id"
          class="review-item"
        >
          <div class="review-item-content">
            <div class="review-item-content-title">
              {{ getSerialNumber(formDefinition.serialNumber, item.index + 1, "", ". ") }}
              {{ item.title }}
            </div>
            <div class="review-item-content-value">
              <span style="white-space: pre-line">{{ getItemValueText(item) }}</span>
            </div>
          </div>
          <div class="review-item-btns" @click="aimToItem(item.id)">
            <van-icon name="aim" size="16" />
          </div>
        </div>
      </template>
      <van-empty v-if="!hasStarted()" description="还未答题" style="margin-top: 50px; color: #ebedf0" />
    </van-popup>
    <!-- 回顾窗口 - end -->
  </van-form>
</template>

<script>
import CollectFormItem from "./CollectFormItem.vue";
import { getItemValueText } from "@/utils/FormUtils.js";

export default {
  components: {
    CollectFormItem,
  },
  props: ["formDefinition", "readonly", "submitTime"],
  data() {
    return {
      scrollEnoughHeight: false,
      reviewWindowShowFlag: false,
    };
  },
  watch: {
    "formDefinition.itemList": {
      deep: true, //深度监听
      handler: function () {
        // 计算各问题的显示状态
        this.displayStatusCalculation();
      },
    },
  },
  computed: {
    getSelectedOptions() {
      return function (options, value) {
        let optionArr = [];
        let valArr = [];
        if (typeof value != "object") {
          valArr.push(value);
        } else {
          valArr = value;
        }

        for (let i = 0; i < valArr.length; i++) {
          for (let k = 0; k < options.length; k++) {
            if (options[k].value === valArr[i]) {
              optionArr.push(options[k]);
            }
          }
        }
        return optionArr;
      };
    },
    // 是否已经开始答题（至少有一题已有答案）
    hasStarted() {
      return function () {
        for (let i = 0; i < this.formDefinition.itemList.length; i++) {
          let item = this.formDefinition.itemList[i];
          if (
            item.display &&
            "value" in item &&
            typeof item.value != "undefined" &&
            (typeof item.value == "number" ? true : item.value.length > 0)
          ) {
            return true;
          }
        }
        return false;
      };
    },
  },
  created() {
    this.displayStatusCalculation();
  },
  mounted() {
    // 重写vant-form的滚动是方法
    this.$refs.form.scrollToField = this.scrollToField;
    window.addEventListener("scroll", this.handleScroll, true); //监听滚动事件
  },
  methods: {
    getItemValueText,
    handleScroll() {
      let top =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset ||
        (document.getElementById("formPreviewWindow") &&
          document.getElementById("formPreviewWindow").scrollTop);
      if (top > document.documentElement.clientHeight) {
        this.scrollEnoughHeight = true;
      } else {
        this.scrollEnoughHeight = false;
      }
    },
    displayStatusCalculation() {
      for (let i = 0; i < this.formDefinition.itemList.length; i++) {
        let item = this.formDefinition.itemList[i];
        if (
          item.relationRule &&
          item.relationRule.conditions &&
          item.relationRule.conditions.length > 0
        ) {
          let conditionalLogic = item.relationRule.conditionalLogic;
          let allPass = false; // 全部通过
          let anyPass = false; // 任一通过
          let passCount = 0; // 验证通过的数量
          for (let j = 0; j < item.relationRule.conditions.length; j++) {
            let condition = item.relationRule.conditions[j];
            let itemId = condition.item;
            let target = this.getItem(itemId); // 目标题目
            if (
              target.display && // 目标题目显示时才能参与计算
              item.index > target.index && // 当前题目必须在目标题目的后面
              "value" in target && // 目标题目需要有value属性
              typeof item.value != "undefined" && // value属性不能是undefined
              (typeof target.value == "number"
                ? true // 评分题有value就代表已有值
                : target.value.length > 0) // 其他题value的length>0代表已有值
            ) {
              if (
                // 多选题 - 选中匹配
                ("checkbox" == target.type &&
                  condition.logic == "select" &&
                  target.value.indexOf(condition.value) >= 0) ||
                // 多选题 - 未选中匹配
                ("checkbox" == target.type &&
                  condition.logic == "unselect" &&
                  target.value.indexOf(condition.value) < 0) ||
                // 非多选题  - 选中匹配
                ("checkbox" != target.type &&
                  condition.logic == "select" &&
                  condition.value == target.value) ||
                // 非多选题  - 未选中匹配
                ("checkbox" != target.type &&
                  condition.logic == "unselect" &&
                  condition.value != target.value)
              ) {
                anyPass = true;
                passCount++;
              }
            }
          }
          // 通过数量和总数量一致
          if (passCount == item.relationRule.conditions.length) {
            allPass = true;
          }
          if (
            (conditionalLogic == "all" && allPass) ||
            (conditionalLogic == "any" && anyPass)
          ) {
            // 验证通过，显示题目
            item.display = true;
          } else {
            item.display = false;
          }
        } else {
          item.display = true;
        }
      }
    },
    getItem(itemId) {
      for (let i = 0; i < this.formDefinition.itemList.length; i++) {
        let item = this.formDefinition.itemList[i];
        if (item.id == itemId) {
          return item;
        }
      }
    },
    scrollToField(itemId) {
      document.getElementById(itemId).scrollIntoView({
        behavior: "smooth",
      });
    },
    // 表单未通过校验
    failed: function () {
      // this.$toast("未通过校验");
      // this.$emit("submit");
    },
    // 表单提交（表单已通过校验）
    submit: function () {
      this.$emit("submit");
    },
    // 打开回顾窗口
    showReviewWindow: function () {
      this.reviewWindowShowFlag = true;
    },
    aimToItem: function (itemId) {
      this.reviewWindowShowFlag = false;
      this.scrollToField(itemId);
    },
  },
};
</script>
<style>
@import url(./CollectForm.css);

.van-empty__description {
  color: #dcdfe1 !important;
}
</style>
<style scoped>
.collect-form-review-btn {
  position: fixed;
  right: 8px;
  bottom: 100px;
  border-radius: 6px;
  color: #fff;
  padding: 10px;
  box-shadow: 0 4px 8px 0 rgb(25 137 257 / 25%) !important;
  background-color: rgba(25, 137, 257, 0.7) !important;
  cursor: pointer;
}

.review-window {
  padding-bottom: 20px;
}

.review-window-title {
  display: block;
  text-align: center;
  font-size: 16px;
  line-height: 50px;
  background: #f7f8fa;
}

.review-item {
  font-size: 12px;
  display: flex;
  border-bottom: #ebedf090 dashed 1px;
  align-items: center;
}

.review-item-content {
  flex: 1;
}
.review-item-btns {
  padding: 15px;
  cursor: pointer;
}
.review-item-content-title {
  padding: 10px 15px 0;
}
.review-item-content-value {
  padding: 4px 15px 10px;
}

.review-btn-enter-active {
  transition: all 0.3s ease;
}
.review-btn-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.review-btn-enter,
.review-btn-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>